import React, { useEffect, useState } from "react";
import Headers from "../components/Header";
import { FaCheckCircle } from "react-icons/fa"; // Importing checkmark icon from react-icons
import NumberFlow from "@number-flow/react"; // Use the default export
import LogoSection from "./LogoSection";
import Footer from "./Footer";
import Weinclude from "../components/Weinclude";
import { useNavigate } from "react-router-dom";
import Button from "@mui/material/Button";
import DuoIcon from "@mui/icons-material/Duo";

const Subscription = () => {
  const [plans, setPlans] = useState([]); // State to store subscription plans
  const [isLoading, setIsLoading] = useState(true); // State to handle loading
  const [error, setError] = useState(null); // State to handle errors
  const navigate = useNavigate();

  const mainContentMap = {
    "Trial plan": "Explore the basics of our lead distribution system.",
    "Startup Plan": "Perfect for startups to begin managing leads efficiently.",
    "Growth Plan": "Scale your lead workflows with advanced features.",
    "Enterprise Plan": "Full-featured solution for large organizations.",
  };

  useEffect(() => {
    const fetchPlans = async () => {
      // const conuntyid = sessionStorage.getItem('conuntyid')
      const serviceid = parseInt(sessionStorage.getItem("serviceid"), 10); // 5
      try {
        // const response = await fetch(`https://apilead.blaccdot.com/ldsstage/masters/subscription/all/${conuntyid}`);
        const response = await fetch(
          `https://apilead.blaccdot.com/ldsstage/masters/subscription/categorybased/5`,
        );
        if (!response.ok) {
          throw new Error("Failed to fetch plans");
        }
        const data = await response.json();
        const subscriptionMasters = data?.data?.subscriptionmasters || [];

        const formattedPlans = subscriptionMasters.map((plan, index) => ({
          id: plan._id,
          subscriptionmasterId: plan.subscriptionmasterId,
          title: plan.title,
          monthlyPrice: plan.monthAmount,
          annualPrice: plan.anualAmount,
          currency: plan.currency,
          taxAmount: plan.taxAmount,
          description: `${plan.creditpoints}`,
          features: plan.textcontent ? Object.values(plan.textcontent) : [],
          highlighted: index === 2,
          mainContent:
            mainContentMap[plan.title] ||
            "A powerful lead management solution.",
        }))
        .filter((plan) => Number(plan.subscriptionmasterId) !== 5);
        setPlans(formattedPlans);
      } catch (error) {
        setError(error.message);
      } finally {
        setIsLoading(false);
      }
    };
    fetchPlans();
  }, []);

  const handleRediract = (plan) => {
    sessionStorage.setItem("subscriptionID", plan.subscriptionmasterId);
    sessionStorage.setItem("planTitle", plan.title);
    sessionStorage.setItem("planAmount", plan.monthlyPrice);
    sessionStorage.setItem("plantax", plan.taxAmount);
    sessionStorage.setItem("planTitle", plan.title);
    sessionStorage.setItem("countrycode", plan.currency);
    sessionStorage.setItem("credit", plan.description);
    navigate("/signup");
    // navigate('/payment');
  };

  const handleCustomFetch = async () => {
    const formID = sessionStorage.getItem("finalFormID");
    const payload = {
      user_type: "custom",
    };
    try {
      const response = await fetch(
        `https://euctostaging.com/lms/api/businessinitialform/update/${formID}`,
        {
          method: "PUT",
          headers: {
            "Content-Type": "application/json",
          },
          body: JSON.stringify(payload),
        },
      );

      const result = await response.json();
      navigate("/appointment");
    } catch (error) {
      console.log("error", error);
    }
  };

  return (
    <>
      <Headers />
      <div className="pricing-container">
        <h1 className="pricing-title">Plans That Fit Your Business</h1>
        <p className="pricing-subtitle">
          From startups to enterprises, find the right solution to boost your
          business growth.
        </p>
        {/* <Button onClick={handleCustomFetch} variant="outlined" startIcon={<DuoIcon />}>Customized Plan</Button> */}
        <button
          onClick={handleCustomFetch}
          style={{ marginBottom: "20px" }}
          className="button-21"
        >
          <DuoIcon style={{ fontSize: "larger", marginRight: "9px" }} />{" "}
          Customized Plan
        </button>

        {/* Mapping through the plans array to render pricing cards dynamically */}
        <div className="pricing-cards">
          {plans.length > 0
            ? plans.map((plan) => (
                <div
                  key={plan.subscriptionmasterId}
                  className={`pricing-card ${plan.highlighted ? "highlighted" : ""}`}
                >
                  {plan.highlighted && (
                    <span className="badgeHigh">MOST POPULAR</span>
                  )}
                  <div className="plan-header mt-2">
                    <h2>{plan.title}</h2>
                    <span style={{ fontSize: "13px", color: "#6A677F" }}>
                      {plan.mainContent}
                    </span>

                    <p className="price mt-3">
                      <NumberFlow
                        value={plan.monthlyPrice}
                        duration={1000}
                        format="currency"
                      />
                      <span style={{ fontSize: "15px", marginLeft: "5px" }}>
                        {plan.currency || ""}
                      </span>
                      <span className="billing-info">+ Taxes</span>
                    </p>
                    <p className="description">
                      {plan.description} credit included
                    </p>
                  </div>
                  <ul className="feature-list">
                    {plan.features.length > 0 ? (
                      plan.features.map((feature, idx) => (
                        <li key={idx}>
                          <FaCheckCircle id="icon" className="icon" /> {feature}
                        </li>
                      ))
                    ) : (
                      <li>No features available</li>
                    )}
                  </ul>

                  <button
                    onClick={() => handleRediract(plan)}
                    className={`choose-plan-button ${plan.highlighted ? "highlighted-button" : ""}`}
                  >
                    Choose {plan.title}
                  </button>
                </div>
              ))
            : !isLoading && <p>No plans available</p>}
        </div>
      </div>
      <>
        <LogoSection />
      </>
      <>
        <Weinclude />
      </>
      <>
        <Footer />
      </>
    </>
  );
};

export default Subscription;
